export const COOKIE_KEY = 'umbrella-token'

export enum STORAGE_KEYS {
  AccessToken = 'access-token',
}
export const KeysToKeepInLocalStorage: string[] = []
